import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { ThreeDots } from "react-loader-spinner";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";


const EditUser = (props) => {
  const statusOption = [
    { value: "enabled",name:"Enabled" },
    { value: "disabled" ,name:"Disabled"},
    { value: "blocked",name:"Blocked"},
  ];

  const [propsData,setPropsData]=useState()
  const [roleData, setRoleData] = useState([]);
  const [roleID, setRoleID] = useState();
  const [roleName, setRoleName] = useState();
  const [firstName, setFirstName] = useState();
  const [surName, setSurName] = useState();
  const [email, setEmail] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [loading, setLoading] = useState(true);
  const [EmailError, setEmailError] = useState(null);
  const [status,setStatus]=useState()
  const [loader,setLoader]=useState(false)
  const [enableDate, setEnableDate] = useState("");
  const [disableDate, setDisableDate] = useState("");


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getRole(token);
    if (props?.location?.state?.edit) {
      setPropsData(props?.location?.state?.item)
      var firstName = props?.location?.state?.item?.first_name;
      var surName = props?.location?.state?.item?.surname;
      var email = props?.location?.state?.item?.email;
      var roleID = props?.location?.state?.item?.role_id;
      var roleName = props?.location?.state?.item?.role_name;
      var status = props?.location?.state?.item?.status;
      var enable_date = props?.location?.state?.item?.enable_date;
      var disable_date = props?.location?.state?.item?.disable_date;
      setFirstName(firstName);
      setSurName(surName);
      setEmail(email);
      setRoleID(roleID);
      setRoleName(roleName);
      setStatus(status)
      setEnableDate(enable_date != null ? enable_date : "")
      setDisableDate(disable_date != null ? disable_date : "")
    }
  }, []);

  const getRole = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let sortedArray=result?.sort(function(a, b) {
          return a.name.localeCompare(b.name);
       });
        setLoading(false);
        setRoleData(sortedArray);
      })
      .catch((error) => console.log("error", error));
  };

  const handleSubmit = () => {
    // if (!firstName) {
    //   setErrorMessage("Please Enter first Name");
    //   setErrorAlert(true);
    //   return;
    // } else if (!surName) {
    //   setErrorMessage("Please Enter SurName");
    //   setErrorAlert(true);
    //   return;
    // } else if (!email) {
    //   setErrorMessage("Please Enter Email");
    //   setErrorAlert(true);
    //   return;
    // } else if (!roleID) {
    //   setErrorMessage("Please Select Role");
    //   setErrorAlert(true);
    //   return;
    // }
    if (
      (enableDate != "Invalid date" && enableDate) && 
      (disableDate != "Invalid date" && disableDate)
    ) {
      if (disableDate < enableDate) {
        setErrorMessage("Disabled date cannot be before Enabled date");
        setErrorAlert(true);
        return;
      }
    }

    setLoader(true)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("id", propsData?.id);
    formdata.append("_method", "PUT");
    formdata.append("role_id", roleID);
    if (enableDate != "Invalid date") {
      formdata.append("enable_date", enableDate ? enableDate : null);
    }
    if (disableDate != "Invalid date") {
      formdata.append("disable_date", disableDate ? disableDate : null);
    }
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/users/update`, requestOptions)
      .then((response) => {
        console.log("here is the response----->", response);
        if (response.status == 200) {
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/manage-users");
        }}
        onConfirm={() => {
          props?.history.push("/manage-users");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"User Updated"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  function isValidEmail(email) {
    return /^[\w\.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/.test(email);
  }
  const emailcheck = (email) => {
    if (email.length > 0) {
      if (!isValidEmail(email)) {
        setEmailError("Email is invalid");
        setEmail();
      } else {
        setEmailError(null);
        setEmail(email);
      }
    } else {
      setEmailError("Please enter email");
    }
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="User Details" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>First Name</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="page_input"
                                  onChange={(e) => {
                                    setFirstName(e.target.value);
                                  }}
                                  defaultValue={firstName}
                                  disabled
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>SurName</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="Content_input"
                                  onChange={(e) => {
                                    setSurName(e.target.value);
                                  }}
                                  defaultValue={surName}
                                  disabled
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Email</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="Content_input"
                                  onChange={(e) => {
                                    emailcheck(e.target.value);
                                  }}
                                  defaultValue={email}
                                  disabled
                                />
                              </div>
                              {EmailError ? (
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: "red",
                                    fontWeight: 400,
                                  }}
                                >
                                  {EmailError}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}></Col>
                        </Row>
                        {roleName!="merchant" && 
                        <Row>
                          <Col md={12}>
                            <Label>Role</Label>                            
                            {loading ? (
                              <ThreeDots
                              height="20"
                              width="70"
                              radius="9"
                              color="#000000"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{}}
                              wrapperClassName=""
                              visible={true}
                            />
                            ) : (
                              <ul
                                className="roles-radio-section d-flex"
                              >
                                {roleData?.map((item, index) => {
                                  if(item.name=="merchant"){
                                    return
                                  }
                                  return(
                                  <li style={{paddingRight:"5%"}} key={index}>
                                    <input
                                      type="radio"
                                      id="radio1"
                                      value={item?.name}
                                      onChange={(e) => {
                                        setRoleName(e.target.value);
                                        setRoleID(item?.id);
                                      }}
                                      checked={roleName == item?.name}
                                    />
                                    <label style={{ paddingLeft: "10px" }}>
                                      {capitalizeFirstLetter(item.name)}
                                    </label>
                                  </li>
                                )})}
                              </ul>
                            )}
                          </Col>
                        </Row>}
                        <Row>
                          <Col md={8} className="mt-2">
                            <Label>Status</Label>
                            <ul
                              // style={{ justifyContent: "space-between" }}
                              className="status-radio-section d-flex"
                            >
                              {statusOption.map((item, index) => (
                                <li key={index} style={{width:"19%"}}>
                                  <input
                                    type="radio"
                                    value={item?.value}
                                    onChange={(e) => {
                                    setStatus(e.target.value)
                                    console.log("here come the status value---->",e.target.value)
                                    }}
                                    checked={status == item?.value}
                                  />
                                  <label style={{ paddingLeft: "10px" }}>
                                    {item.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Enable Date</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setEnableDate(
                                      e.target.value ? e.target.value : ""
                                    );
                                  }}
                                  value={enableDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Disable Date</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setDisableDate(e.target.value ? e.target.value : "");
                                  }}
                                  value={disableDate}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/manage-users");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditUser;
